import { WorkspaceSmsPhoneNumbersRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/sms/phone-numbers')({
  component: WorkspaceSmsPhoneNumbersRoute,
});
